export const auditLogEvent = {
  // The same reconciliation can have different frozen values in different events.
  AuditLogReconciliationSnapshot: {
    keyFields: false as const,
  },
  // Reference budgets and detail pagination vary per query; retain each query's snapshot.
  AuditLogEventSummary: {
    keyFields: false as const,
  },
  AuditLogEvent: {
    keyFields: false as const,
  },
}
